import { render, staticRenderFns } from "./returnPolicy.vue?vue&type=template&id=70c658fc&scoped=true&"
import script from "./returnPolicy.vue?vue&type=script&lang=js&"
export * from "./returnPolicy.vue?vue&type=script&lang=js&"
import style0 from "./returnPolicy.vue?vue&type=style&index=0&id=70c658fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c658fc",
  null
  
)

export default component.exports